module.exports = __webpack_public_path__ + "static/media/beans.69443600.jpg";